import React from "react";
import { HStack, Icon, Text, VStack, BoxProps, Box } from "@chakra-ui/react";
import TinyHeading from "components/TinyHeading";

export type WalletAssetProps = {
  title: React.ReactNode;
  icon: React.FC;
  value?: string | number | JSX.Element;
  link?: { label: string; href: string };
} & BoxProps;

const WalletAsset: React.FC<WalletAssetProps> = ({
  title,
  icon,
  value,
  link,
  ...rest
}) => {
  return (
    <Box position="relative" w="full" bg="dark.400">
      <VStack
        align="flex-start"
        px={4}
        py="3.5"
        gap="0.5"
        overflow="hidden"
        color="bright.500"
        spacing="1.5"
        {...rest}
      >
        <TinyHeading>{title}</TinyHeading>

        <HStack overflow="hidden" w="full">
          <Icon as={icon} w="7" h="auto" color="secondary.500" />
          <Text fontSize="2xl" lineHeight="6" isTruncated>
            {value ?? "–"}
          </Text>
        </HStack>
      </VStack>

      {link && (
        <Box
          as="a"
          href={link.href}
          target="_blank"
          position="absolute"
          top="0"
          right="0"
          fontSize="xs"
          fontWeight="semibold"
          px="3"
          py="1"
          bg="dark.500"
          _hover={{
            bg: "dark.600",
          }}
        >
          {link.label}
        </Box>
      )}
    </Box>
  );
};

export default WalletAsset;
